export default "__VITE_ASSET__a69b8d16__"